/** Canonical email for API payloads (trim + lowercase). */
export function normalizeEmail(value) {
  if (value == null) return "";
  return String(value).trim().toLowerCase();
}
